'use strict';

var React = require('react');

var SvgSmileyNeutralMajor = function SvgSmileyNeutralMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 10c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10-10-4.486-10-10zm7.707-1.293a1 1 0 1 1-1.414-1.414 1 1 0 0 1 1.414 1.414zm4.586-1.414a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414zm1.414 5a1 1 0 0 0-.707-.293h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 .707-1.707z"
  }));
};

exports.SvgSmileyNeutralMajor = SvgSmileyNeutralMajor;
